/* WBX search: the header search panel, and the same lists on /search and the 404 page.
   The index is #WbxSearchIndex, written by snippets/wbx-search.liquid. Icon circles are borrowed from the desktop
   menu sheets (.wbx-dd), so they always match the menu. Filtering runs here, with no network call; Enter goes to /search. */
(function () {
  'use strict';
  if (window.WbxSearch) return;

  var DESK = window.matchMedia('(min-width: 990px)');
  var STOP = { a: 1, an: 1, the: 1, is: 1, are: 1, do: 1, does: 1, i: 1, im: 1, me: 1, my: 1, for: 1, of: 1, to: 1, in: 1, on: 1, at: 1,
    and: 1, or: 1, with: 1, you: 1, your: 1, we: 1, it: 1, can: 1, get: 1, need: 1, near: 1, clermont: 1, fl: 1, florida: 1 };
  var COL1 = { p: 1, s: 1, c: 1, x: 1 };
  var BASE = { p: 4, s: 3, x: 3, c: 2, g: 2, b: 1, l: 0 };
  var IDX = null, ICON = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/&/g, ' and ').replace(/['’`]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function stem(w) {
    if (w.length > 4 && /ies$/.test(w)) return w.slice(0, -3) + 'y';
    if (w.length > 4 && /(ches|shes|sses|xes|oes)$/.test(w)) return w.slice(0, -2);
    if (w.length > 3 && /s$/.test(w) && !/(ss|us|is)$/.test(w)) return w.slice(0, -1);
    return w;
  }
  function words(s) {
    var out = [];
    norm(s).split(' ').forEach(function (w) { if (w) out.push(stem(w)); });
    return out;
  }

  function index() {
    if (IDX) return IDX;
    IDX = [];
    var el = document.getElementById('WbxSearchIndex');
    if (el) { try { IDX = JSON.parse(el.textContent) || []; } catch (e) { IDX = []; } }
    IDX.forEach(function (e, i) {
      e.n = i; e.col = COL1[e.g] ? 1 : 2;
      e.wt = words(e.t); e.wk = words(e.k); e.wd = words(e.d); e.nt = norm(e.t);
    });
    return IDX;
  }

  // 2 = whole word, 1 = word starts with the token (allowed for the word being typed, or tokens of 4+ letters)
  function hit(list, tok, prefix) {
    var best = 0;
    for (var i = 0; i < list.length; i++) {
      if (list[i] === tok) return 2;
      if (prefix && list[i].indexOf(tok) === 0) best = 1;
    }
    return best;
  }

  // Ranked matches. Entries must cover as many query words as the best entry does, so a stray word
  // ("cockroach spray") narrows nothing away instead of emptying the list.
  function search(q) {
    var data = index(), nq = norm(q), all = words(q);
    var toks = all.filter(function (t) { return !STOP[t]; });
    if (!toks.length) toks = all;
    if (!toks.length) return [];
    // A word that some entry has whole ("rat") stops counting as the start of longer words ("rate", "rating").
    var whole = toks.map(function (t) {
      return data.some(function (e) { return hit(e.wt, t) === 2 || hit(e.wk, t) === 2 || hit(e.wd, t) === 2; });
    });
    var res = [], top = 0;
    data.forEach(function (e) {
      var s = 0, m = 0;
      toks.forEach(function (t, i) {
        var pre = !whole[i] && (i === toks.length - 1 || t.length >= 4);
        var a = hit(e.wt, t, pre), b = hit(e.wk, t, pre), c = hit(e.wd, t, pre);
        var v = Math.max(a ? (a === 2 ? 10 : 7) : 0, b ? (b === 2 ? 6 : 4) : 0, c ? (c === 2 ? 3 : 2) : 0);
        if (v) { m++; s += v; }
      });
      if (!m) return;
      if (nq && e.nt.indexOf(nq) === 0) s += 8;
      s += BASE[e.g] || 0;
      if (m > top) top = m;
      res.push({ e: e, s: s, m: m });
    });
    return res.filter(function (r) { return r.m === top; })
      .sort(function (a, b) { return b.s - a.s || a.e.n - b.e.n; })
      .map(function (r) { return r.e; });
  }

  function icon(h) {
    if (!h || h === '-') return '';
    if (ICON[h] !== undefined) return ICON[h];
    var src = document.querySelector('.wbx-dd a[id$="-' + h + '"] .wbx-ico') || document.querySelector('#WbxSearchIcons [data-i="' + h + '"]');
    var pair = src && src.classList.contains('wbx-ico--pair');
    ICON[h] = src ? '<span class="wbx-s__ico' + (pair ? ' wbx-s__ico--pair' : '') + '" aria-hidden="true">' + src.innerHTML + '</span>' : '';
    return ICON[h];
  }

  function row(e, id, opt) {
    var chip = e.col === 1 && e.c && e.c !== '-' ? '<span class="wbx-s__kind">' + esc(e.c) + '</span>' : '';
    return '<a class="wbx-s__it' + (e.col === 2 ? ' wbx-s__it--pg' : '') + '" href="' + esc(e.u) + '"' +
      (opt ? ' role="option" id="' + id + '" aria-selected="false"' : '') + '>' +
      (e.col === 1 ? icon(e.i) : '') +
      '<span class="wbx-s__tx"><span class="wbx-s__lb">' + esc(e.t) + '</span>' + (e.d ? '<span class="wbx-s__ds">' + esc(e.d) + '</span>' : '') + '</span>' +
      chip + '</a>';
  }

  // o: { l1, l2 (row limits per column), id (option id prefix), opt (listbox roles), foot, tel, phone }
  function build(q, o) {
    o = o || {};
    var c1, c2, has = q && q.trim();
    if (has) {
      var list = search(q);
      c1 = list.filter(function (e) { return e.col === 1; }).slice(0, o.l1 || 6);
      c2 = list.filter(function (e) { return e.col === 2; }).slice(0, o.l2 || 5);
    } else {
      var d = index().filter(function (e) { return e.o > 0; }).sort(function (a, b) { return a.o - b.o; });
      c1 = d.filter(function (e) { return e.col === 1; });
      c2 = d.filter(function (e) { return e.col === 2; });
    }
    var n = 0, pre = o.id || 'wbxs', tel = o.tel || 'tel:+14073607325', h = '<div class="wbx-s__grid">';
    function col(label, list) {
      return '<div class="wbx-s__col"><span class="wbx-s__ey">' + label + '</span>' +
        list.map(function (e) { return row(e, pre + '-' + (n++), o.opt); }).join('') + '</div>';
    }
    if (!c1.length && !c2.length) h += '<p class="wbx-s__empty">Nothing for that. Try a pest, a service, or <a href="' + esc(tel) + '">call us</a>.</p>';
    if (c1.length) h += col('Pests &amp; services', c1);
    if (c2.length) h += col('Pages', c2);
    h += '</div>';
    if (o.foot !== false) {
      var lead = has
        ? '<a class="wbx-s__all" href="/search?q=' + encodeURIComponent(q.trim()) + '&amp;options%5Bprefix%5D=last">' +
          (DESK.matches ? 'Press Enter for every result for' : 'See every result for') + ' "' + esc(q.trim()) + '"</a>'
        : '<a href="' + esc(tel) + '">Rather talk? Call or text ' + esc(o.phone || '(407) 360-7325') + '</a>';
      h += '<div class="wbx-s__foot">' + lead + '<span class="wbx-s__hint">Try a pest, a service, or "price"</span></div>';
    }
    return { html: h, count: c1.length + c2.length };
  }

  function Panel(root) {
    var btn = root.querySelector('.wbx-s__btn'), pop = root.querySelector('.wbx-s__pop');
    var input = root.querySelector('.wbx-s__input'), sheet = root.querySelector('.wbx-s__sheet');
    var form = root.querySelector('form'), hdr = root.closest('.wbx-hdr') || document.documentElement;
    var o = { id: 'wbxs', opt: true, tel: root.getAttribute('data-tel'), phone: root.getAttribute('data-phone') };
    var opts = [], active = -1;
    if (!btn || !pop || !input || !sheet) return;

    function px(k, v) { pop.style.setProperty(k, Math.round(v) + 'px'); }
    // Desktop: the field covers the nav cell (logo to the search button), the sheet hangs under the bar, centred.
    function place() {
      if (!DESK.matches) { pop.removeAttribute('style'); return; }
      var org = pop.getBoundingClientRect();
      var wrap = root.closest('.header-wrapper') || root.closest('header') || document.body;
      var wr = wrap.getBoundingClientRect();
      var logo = wrap.querySelector('.header__heading-link') || wrap.querySelector('.header__heading');
      var left = (logo ? logo.getBoundingClientRect().right : wr.left + 200) + 24;
      var right = btn.getBoundingClientRect().right;
      var vw = document.documentElement.clientWidth, sw = Math.min(1200, vw - 48);
      px('--wbx-fl', left - org.left); px('--wbx-fw', Math.max(280, right - left)); px('--wbx-ft', (wr.top + wr.bottom) / 2 - 24 - org.top);
      px('--wbx-st', wr.bottom - org.top); px('--wbx-sl', (vw - sw) / 2 - org.left); px('--wbx-sw', sw);
      px('--wbx-sm', Math.max(260, window.innerHeight - wr.bottom - 16));
    }
    function setActive(i) {
      if (opts[active]) { opts[active].classList.remove('is-active'); opts[active].setAttribute('aria-selected', 'false'); }
      active = i;
      if (opts[i]) {
        opts[i].classList.add('is-active'); opts[i].setAttribute('aria-selected', 'true');
        input.setAttribute('aria-activedescendant', opts[i].id);
        opts[i].scrollIntoView({ block: 'nearest' });
      } else input.removeAttribute('aria-activedescendant');
    }
    function render() {
      sheet.innerHTML = build(input.value, o).html;
      opts = [].slice.call(sheet.querySelectorAll('[role="option"]'));
      active = -1; input.removeAttribute('aria-activedescendant');
    }
    function lock(on) { document.documentElement.classList.toggle('wbx-s-lock', on && !DESK.matches); }
    function open() {
      if (!pop.hidden) return;
      pop.hidden = false;
      root.classList.add('is-open'); hdr.classList.add('wbx-s-open');
      btn.setAttribute('aria-expanded', 'true'); input.setAttribute('aria-expanded', 'true');
      place(); render(); lock(true);
      input.focus(); input.select();
    }
    function close(refocus) {
      if (pop.hidden) return;
      pop.hidden = true;
      root.classList.remove('is-open'); hdr.classList.remove('wbx-s-open');
      btn.setAttribute('aria-expanded', 'false'); input.setAttribute('aria-expanded', 'false');
      lock(false);
      if (refocus !== false) btn.focus();
    }

    btn.addEventListener('click', function (e) { e.preventDefault(); if (pop.hidden) open(); else close(); });
    input.addEventListener('input', render);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (opts.length) setActive(active + 1 < opts.length ? active + 1 : 0); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (opts.length) setActive(active > 0 ? active - 1 : opts.length - 1); }
      else if (e.key === 'Enter' && opts[active]) { e.preventDefault(); window.location.href = opts[active].href; }
    });
    pop.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); close(); } });
    form.addEventListener('submit', function (e) { if (!input.value.trim()) { e.preventDefault(); input.focus(); } });
    root.querySelector('[data-wbx-close]').addEventListener('click', function () { close(); });
    document.addEventListener('pointerdown', function (e) {
      if (!pop.hidden && !pop.contains(e.target) && !btn.contains(e.target)) close(false);
    });
    pop.addEventListener('focusout', function (e) {
      if (DESK.matches && e.relatedTarget && !pop.contains(e.relatedTarget) && !btn.contains(e.relatedTarget)) close(false);
    });
    window.addEventListener('resize', function () { if (!pop.hidden) place(); });
    var onBp = function () { if (!pop.hidden) { place(); lock(true); render(); } };
    if (DESK.addEventListener) DESK.addEventListener('change', onBp); else if (DESK.addListener) DESK.addListener(onBp);
  }

  // Static lists for /search and the 404 page: <div data-wbx-search-mount data-q="" data-l1="8" data-l2="8" data-foot="false" data-empty="hide">
  function mount(el) {
    var root = document.querySelector('[data-wbx-search]');
    var r = build(el.getAttribute('data-q') || '', {
      id: el.id || 'wbxi', l1: +el.getAttribute('data-l1') || 8, l2: +el.getAttribute('data-l2') || 8,
      foot: el.getAttribute('data-foot') !== 'false',
      tel: root && root.getAttribute('data-tel'), phone: root && root.getAttribute('data-phone')
    });
    el.classList.add('wbx-s__sheet', 'wbx-s__sheet--inline');
    var none = !r.count && el.getAttribute('data-none') && document.getElementById(el.getAttribute('data-none'));
    if (none) none.hidden = false;
    if (!r.count && el.getAttribute('data-empty') === 'hide') {
      var wrap = el.closest('[data-wbx-search-block]');
      (wrap || el).hidden = true;
      return;
    }
    el.innerHTML = r.html;
  }

  window.WbxSearch = { search: search, build: build };
  function init() {
    [].forEach.call(document.querySelectorAll('[data-wbx-search]'), Panel);
    [].forEach.call(document.querySelectorAll('[data-wbx-search-mount]'), mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
